export default __webpack_public_path__ + "static/media/calendar.7c5a1535.svg";